<template>

    <div class="equality-main">

        <!-- copy from here -->
        <div class="container-fluid p-0">

            <div class="row justify-content-center d-none d-md-block">

                <table style="width:100%" class="main-nav-table">
                    <tr>
                        <td v-if="hideoverview == false" class="large-button-container">
                            <div class="p-1 large-button rounded green" v-bind:class="{'selected':step == 1}" @click="step = 1">
                                Översikt
                            </div>
                        </td>
                        <td v-if="hidesexdistribution == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hidesexdistribution == false" class="large-button-container">
                            <div class="p-1 large-button rounded green" v-bind:class="{'selected':step == 2}" @click="step = 2">
                                Könsfördelning
                            </div>
                        </td>
                        <td v-if="hideopportunities == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideopportunities == false" class="large-button-container">
                            <div class="p-1 large-button rounded green" v-bind:class="{'selected':step == 3}" @click="step = 3">
                                Möjligheter till<br />utveckling i arbetet
                            </div>
                        </td>
                        <td v-if="hideequalpay == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideequalpay == false" class="large-button-container">
                            <div class="p-1 large-button rounded green" v-bind:class="{'selected':step == 4}" @click="step = 4">
                                Lika lön för<br />lika arbete
                            </div>
                        </td>
                        <td v-if="hideequalpayequalwork == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideequalpayequalwork == false" class="large-button-container">
                            <div class="p-1 large-button rounded green" v-bind:class="{'selected':step == 5}" @click="step = 5">
                                Lika lön för<br />likvärdigt arbete
                            </div>
                        </td>
                        <td v-if="hideresult == false" class="text-center p-0" style="padding-right:3px;padding-left:3px;width:21px;">
                            <img width="15" src="/images/Arrow20x9.jpg">
                        </td>
                        <td v-if="hideresult == false" class="large-button-container">
                            <div class="p-1 large-button rounded green" v-bind:class="{'selected':step == 6}" @click="step = 6">
                                Resultatet
                            </div>
                        </td>
                    </tr>
                </table>

            </div>

            <div class="container-fluid p-0">



                <div class="row justify-content-center mt-3">

                    <div v-if="hideoverview == false" class="p-0 d-block d-md-none col-12">
                        <div class="lime my-1 mobile-button rounded" v-bind:class="{'selected':step == 1}" @click="step = 1">
                            <span v-html="'Översikt'"></span>
                        </div>
                    </div>
                    <div v-if="step == 1" class="col-12 p-0">
                        <div class="col-12 p-0">
                            <v-expansion-panels variant="accordion">
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step1-verktyget-genererar-underlag"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Mellan"
                                    data-manual-info-tags="equality,overview,underlag">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Verktyget genererar ett antal underlag ur jämställdhetsperspektiv
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded" data-manual-info-body>
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Kvinnors och mäns löner inom IF Metall
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Inom IF Metall tjänar kvinnor som grupp mellan 3 och 15 procent mindre än män som grupp. Löneskillnaden varierar mellan avtalsområden. Minst var löneskillnaderna 2010 inom Stål- och metall och Tvättindustrin.<br><br>
                                                            Inom Teknikavtalet IF Metall, Gruvavtalet och Allokemisk Industri var löneskillnaderna mellan kvinnor och män cirka 6 procent. <br><br>
                                                            Störst är löneskillnaderna inom Motorbransch- och Svemekavtalen. Här arbetar mycket få kvinnor.<br><br>
                                                            Löneskillnaderna mellan könen har i princip varit desamma under den senaste tioårsperioden.

                                                        </div>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Olika orsaker bakom kvinnors lägre genomsnittliga löneläge
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Det finns olika orsaker bakom kvinnors lägre löneläge som grupp betraktat.<br>
                                                            Några orsaker är:
                                                        </div>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-orange'>
                                                                <v-expansion-panel-title color="orange">
                                                                    Arbeten som förknippas med kvinnor uppfattas som enklare
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        IF Metalls egna undersökningar visar på ett samband mellan kvinnoandel i ett företag och lönenivån. Ju högre kvinnoandel, desto lägre lönenivå totalt på företaget. Bakom detta kan självklart ligga att de jobb som utförs här är mindre kvalificerade. Sannolikt är detta inte den enda förklaringen. Kvinnors arbete värderas ibland också lägre. Det är ett förhållande som spiller över på männens lönenivå i dessa företag.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-orange'>
                                                                <v-expansion-panel-title color="orange">
                                                                    Kvinnor missgynnas direkt eller indirekt i lönesammanhang
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        Risken för osakliga löneskillnader ökar om lönesystem saknas eller om ingrupperingsregler är otydliga. Undersökningen Industriarbetarnas arbetsvillkor 2010 visar att kvinnors löneandel av männens var högre på arbetsplatser där det fanns lönesystem inom Teknikavtalet IF Metall.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-orange'>
                                                                <v-expansion-panel-title color="orange">
                                                                    Kvinnors större uttag av föräldraledighet
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        Att kvinnor tar ut större del av föräldraledigheten kan leda till det som brukar kallas statistisk diskriminering. Arbetsgivaren betraktar kvinnor som en mer osäker arbetskraft genom barnafödande. Det är ett förhållande som drabbar alla kvinnor oavsett om de föder barn eller ej.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-orange'>
                                                                <v-expansion-panel-title color="orange">
                                                                    Kvinnor utför mindre kvalificerade arbeten än män
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        Det är inte ovanligt att kvinnor tilldelas mer okvalificerade arbeten än män trots att deras utbildningsbakgrund är densamma.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Lönekartläggning enligt diskrimineringslagen
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Det finns flera partsgemensamma material som beskriver hur lönekartläggning och analys kan genomföras enligt diskrimineringslagen:<br>
                                                            <ul>
                                                                <li>Jämställd lön (Industriarbetsgivarna, Unionen, Sveriges Ingenjörer och IF Metall).</li>
                                                                <li>Lönekartläggning (Teknikarbetsgivarna, Unionen, Sveriges Ingenjörer och IF Metall).</li>
                                                            </ul>
                                                            Dessutom har IF Metall tagit fram materialet Hållbart arbete – Godkänd jämställdhetsplan. Materialet visar hur man kan arbeta för att ta fram en jämställdhetsplan och innehållet i denna. Handlingsplan för jämställda löner är en del i en jämställdhetsplan.<br><br>
                                                            Samtliga skrifter finns att hämta på medlemsportalen via www.ifmetall.se.
                                                        </div>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Diskrimineringslagen 3 kap. 2 § Utjämna och förhindra löneskillnader mellan kvinnor och män som utför lika eller likvärdigt arbete
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        <b>2 §</b> Arbetsgivare och arbetstagare ska särskilt verka för att utjämna och förhindra skillnader i löner och andra anställningsvillkor mellan kvinnor och män som utför arbete som är att betrakta som lika eller likvärdigt. De ska också främja lika möjligheter till löneutveckling för kvinnor och män.<br><br>
                                                                        Ett arbete är att betrakta som likvärdigt med ett annat arbete om det utifrån en sammantagen bedömning av de krav arbetet ställer samt dess natur kan anses ha lika värde som det andra arbetet. Bedömningen av de krav arbetet ställer ska göras med beaktande av kriterier som kunskap och färdigheter, ansvar och ansträngning. Vid bedömningen av arbetets natur ska särskilt arbetsförhållandena beaktas.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Diskrimineringslagen 3 kap. 10 § Kartläggning
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        <b>10 §</b> I syfte att upptäcka, åtgärda och förhindra osakliga skillnader i lön och andra anställningsvillkor mellan kvinnor och män ska arbetsgivaren vart tredje år kartlägga och analysera <br>
                                                                        -	bestämmelser och praxis om löner och andra anställningsvillkor som tillämpas hos arbetsgivaren, och<br>
                                                                        -	löneskillnader mellan kvinnor och män som utför arbete som är att betrakta som lika eller likvärdigt.<br><br>
                                                                        Arbetsgivaren ska bedöma om förekommande löneskillnader har direkt eller indirekt samband med kön. Bedömningen ska särskilt avse skillnader mellan<br>
                                                                        -	kvinnor och män som utför arbete som är att betrakta som lika, och<br>
                                                                        -	grupp med arbetstagare som utför arbete som är eller brukar anses vara kvinnodominerat och grupp med arbetstagare som utför arbete som är att betrakta som likvärdigt med sådant arbete men inte är eller brukar anses vara kvinnodominerat.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Diskrimineringslagen 3 kap. 11 § Handlingsplan för jämställda löner
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        11 § Arbetsgivaren ska vart tredje år upprätta en handlingsplan för jämställda löner och där redovisa resultatet av kartläggningen och analysen enligt 10 §. I planen ska anges vilka lönejusteringar och andra åtgärder som behöver vidtas för att uppnå lika lön för arbete som är att betrakta som lika eller likvärdigt. Planen ska innehålla en kostnadsberäkning och en tidsplanering utifrån målsättningen att de lönejusteringar som behövs ska genomföras så snart som möjligt och senast inom tre år.<br><br>
                                                                        En redovisning och en utvärdering av hur de planerade åtgärderna genomförts ska tas in i efterföljande handlingsplan.<br><br>
                                                                        Skyldigheten att upprätta en handlingsplan för jämställda löner gäller inte arbetsgivare som vid det senaste kalenderårsskiftet sysselsatte färre än 25 arbetstagare.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Diskrimineringslagen 3 kap. 11 § Information
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        <b>12 §</b> Arbetsgivaren ska förse en arbetstagarorganisation i förhållande till vilken arbetsgivaren är bunden av kollektivavtal med den information som behövs för att organisationen ska kunna samverka vid kartläggning, analys och upprättande av handlingsplan för jämställda löner.<br><br>
                                                                        Avser informationen uppgifter om lön eller andra förhållanden som berör en enskild arbetstagare gäller reglerna om tystnadsplikt och skadestånd i 21, 22 och 56 § lagen (1976:580) om medbestämmande i arbetslivet. I det allmännas verksamhet tillämpas i stället 10 kap. 11–14 § och 12 kap. 2 § offentlighets- och sekretesslagen (2009:400). Lag (2009:526).
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Löneanalys enligt kollektivavtalet
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Hur en löneanalys enligt kollektivavtalet kan genomföras beskrivs i IF Metalls material Hållbart arbete – Godkänd jämställdhetsplan.<br><br>
                                                            <b>Sakligt omotiverade löneskillnader ska inte förekomma</b><br>
                                                            Avtalen innehåller ofta regler om löneprinciper. Dessa anger efter vilka grunder som arbetstagarens lön ska bestämmas. Genomgående för löneprinciperna är att de framhåller sambandet mellan verksamhetens/arbetsuppgifternas krav och lönens storlek. Löneprinciperna anger också – mer eller mindre detaljrikt – vilka faktorer som ska påverka lönen. <br><br>
                                                        </div>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Teknikavtalet IF Metall, Gemensamma metallavtalet, Buteljglas- och Byggnadsämnesindustrin
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        Avtalen anger att:<br>
                                                                        ”Diskriminerande eller andra sakligt omotiverade skillnader i löner och andra anställningsvillkor ska inte förekomma. De lokala parterna ska inför löneförhandlingar, som ska ske enligt avtalet, analysera om diskriminerande eller på annat sätt sakligt omotiverade löneskillnader förekommer. Framgår det av dessa analyser att omotiverade löneskillnader finns i företaget ska dessa justeras i samband med löneförhandlingarna”.<br><br>
                                                                        Texten tar sikte på både diskriminerande löneskillnader i strid med gällande lagstiftning på området och på löneskillnader som inte sakligt kan motiveras utifrån avtalens löneprinciper. Det sistnämnda innebär ett längre gående skydd mot osaklighet i lönesättningen än exempelvis diskrimineringslagens diskrimineringsförbud. Även löneskillnader inom ett kön ska sakligt kunna förklaras.<br><br>
                                                                        Liknande skrivningar finns inom Motorbranschavtalet och Oljeraffinaderier.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Stål- och metallavtalet samt Gruvavtalet
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        Avtalen anger att:<br>
                                                                        ”Samma principer för lönesättningen ska gälla för kvinnor och män liksom för yngre och äldre arbetare och oavsett etnisk tillhörighet.”<br><br>
                                                                        Det är viktigt att kontrollera vad som gäller i det egna kollektivavtalet.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Att koppla samman kollektivavtalsbestämmelser med diskrimineringslagens regelverk om osakliga löneskillnader mellan kvinnor och män
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Av diskrimineringslagens övergångsbestämmelser framgår att arbetsgivarens skyldigheter att genomföra lönekartläggning ska fullgöras första gången 2009 eller då bestämmelserna första gången blir tillämplig. För företag som etableras först 2010 kommer arbetsgivaren redan första året att omfattas av skyldigheten att kartlägga och analysera löneskillnader, dvs. 2010 och därefter vart tredje år.<br><br>
                                                            För att på ett systematiskt och effektivt sätt arbeta med osakliga löneskillnader mellan kvinnor och män finns det fördelar med att koppla samman löneanalys och kön enligt kollektivavtalen med diskrimineringslagens regelverk. <br><br>
                                                            Arbetet kan då läggas upp på följande sätt:<br>
                                                            -	Årlig kartläggning och analys ska göras inför löneförhandlingarna. Sakligt omotiverade löneskillnader ska justeras i samband med löneförhandlingarna. <br>
                                                            -	Vart tredje år göra jämförelser över kollektivavtalsgränserna.<br><br>
                                                        </div>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Principskiss för sammankoppling av löneanalys utifrån kön och lönekartläggning enligt diskrimineringslagen
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        <img src="/images/PrincipskissLoneanalys.PNG" alt="Principskiss för sammankoppling av löneanalys utifrån kön och lönekartläggning enligt diskrimineringslagen"><br><br>
                                                                        Ovanstående arbetsmodell innebär utifrån jämställdhetsperspektivet att respektive facklig organisation inför löneförhandlingarna analyserar löneskillnader mellan kvinnor och män när det gäller grunder för lönesättningen, samt för lika och likvärdigt arbete inom det egna kollektivavtalet. I det fall att osakliga löneskillnader upptäcks ska dessa rättas till i samband löneförhandlingarna.
                                                                        Därefter sammanställs och analyseras grunderna för lönesättningen för samtliga anställda på arbetsplatsen. Kvinnodominerade arbeten jämförs med arbeten som inte är kvinnodominerade inom andra kollektiv enligt diskrimineringslagens regelverk.
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <v-expansion-panels variant="accordion">
                                                            <v-expansion-panel class='theme-green'>
                                                                <v-expansion-panel-title color="green">
                                                                    Löneanalys varje år utifrån kön och lönekartläggning vart tredje år utifrån diskrimineringslagen
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div class="pb-2">
                                                                        <img src="/images/Lonekartlaggning.PNG" alt="Löneanalys varje år utifrån kön och lönekartläggning vart tredje år utifrån diskrimineringslagen">
                                                                    </div>
                                                                    <div class="mt-5">

                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step1-konsfordelning-alla-befattningar"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Enkel"
                                    data-manual-info-tags="equality,overview,konsfordelning">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Könsfördelning i alla befattningar
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            Arbete för ökad jämställdhet innebär att alltid ha kunskap om hur fördelningen
                                            mellan kvinnor och män är i befattningarna. Jämställda befattningar innehåller
                                            40–60 procent av det ena könet. Om en befattning innehåller mer än 60 procent
                                            kvinnor betraktas den som kvinnodominerad och ska analyseras särskilt
                                            lönemässigt när det gäller likvärdigt arbete.<br><br>
                                            Verktyget Hållbart arbete levererar automatiskt rapporter som anger kvinnors andel
                                            i befattningen.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step1-mojligheter-utveckling"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Enkel"
                                    data-manual-info-tags="equality,overview,utveckling">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Möjligheter för kvinnor och män att utvecklas i arbetet
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            En viktig förklaring till löneskillnader mellan kvinnor och män är att kvinnor generellt sett har givits sämre möjligheter till kompetensutveckling trots att både diskrimineringslag och jämställdhetsavtal anger att möjligheterna ska vara desamma. <br><br>
                                            Viktiga inslag i jämställdhetsarbetet är därför att:
                                            <ul>
                                                <li>Systematiskt arbeta för att utveckla jobben i kvinnodominerade befattningar.</li>
                                                <li>Systematiskt följa kvinnors och mäns utvecklingsmöjligheter i samma befattning.</li>
                                            </ul>
                                            Verktyget Hållbart arbete är ett stöd för lokalt jämställdhetsarbete.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step1-lon-lika-arbete"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Enkel"
                                    data-manual-info-tags="equality,overview,lika-arbete">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Lön för kvinnor och män i lika arbete
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            Diskrimineringslagen och kollektivavtalen anger att kvinnor och män ska ha lika lön för lika arbete. Verktyget Hållbart arbete ger möjlighet att systematiskt följa kvinnors och mäns löner i lika arbete.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step1-vardera-likvardiga"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Enkel"
                                    data-manual-info-tags="equality,overview,likvardigt-arbete">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Värdera om arbeten är likvärdiga
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            Diskrimineringslagen och kollektivavtalen anger att kvinnor och män ska ha lika lön för likvärdigt arbete. Verktyget Hållbart arbete ger möjlighet till att systematiskt följa kvinnors och mäns löner vid likvärdigt arbete.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        VERKTYGET – LOKALT REGELVERK
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <common-rule v-bind:disabled="writeoverview == false" regulationtype="2"></common-rule>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>


                        </div>
                    </div>
                    <div v-if="hidesexdistribution == false" class="p-0 d-block d-md-none col-12">
                        <div class="lime my-1 mobile-button rounded" v-bind:class="{'selected':step == 2}" @click="step = 2">
                            <span v-html="'Könsfördelning'"></span>
                        </div>
                    </div>
                    <div v-if="step == 2" class="col-12 p-0">
                        <div class="col-12 p-0">
                            <v-expansion-panels variant="accordion">
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step2-varfor-konsfordelning"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Enkel"
                                    data-manual-info-tags="equality,konsfordelning,overview">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Varför är det viktigt att följa könsfördelningen i olika befattningar
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            Diskrimineringslag och jämställdhetsavtal anger att lokala parter ska arbeta för att befattningar successivt blir mer jämställda. En jämställd befattning innehåller 40–60 procent av det ena könet.<br><br>
                                            Jämställda befattningar ger möjligheter till en mer jämställd utveckling i arbete och lön. Jämställda befattningar innebär också att risken för värdediskriminering baserat på kön minskar.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        VERKTYGET – SKAPA BEFATTNINGAR OCH SKRIV IN ANSTÄLLDA
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Skapa befattningar
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <manage-workpositions v-bind:disabled="writesexdistribution == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected" @job-positions-changed="jobPositionsChanged"></manage-workpositions>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Skriv in anställda
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <wage-employee-admin v-bind:disabled="writesexdistribution == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-admin>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Länk till rapport
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <equality-report-gender-distribution v-bind:disabled="writesexdistribution == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></equality-report-gender-distribution>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>


                        </div>
                    </div>
                    <div v-if="hideopportunities == false" class="p-0 d-block d-md-none col-12">
                        <div class="lime my-1 mobile-button rounded" v-bind:class="{'selected':step == 3}" @click="step = 3">
                            <span v-html="'Möjligheter för kvinnor och män till utveckling i arbetet'"></span>
                        </div>
                    </div>
                    <div v-if="step == 3" class="col-12 p-0">
                        <div class="col-12 p-0">
                            <v-expansion-panels variant="accordion">
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step3-arbetsorganisation"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Mellan"
                                    data-manual-info-tags="equality,utveckling,arbetsorganisation">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Arbetsorganisation
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            För att skapa en jämställd utveckling för kvinnor och män måste utvecklingsmöjligheterna i de olika befattningarna synliggöras. Det är ett arbete som kan göras i följande steg:<br><br>
                                            1.	Beskriva arbetsuppgifterna i respektive befattning.<br>
                                            2.	Definiera olika utvecklingsblock inom respektive befattning.<br>
                                            3.	Ange vilka arbetsuppgifter som tillhör grundarbete respektive olika utvecklingsblock.<br>
                                            Har ovanstående underlag redan lagts in i verktyget är det bara att klicka på ”Länk till rapport” och välja Befattning. Då visas en rapport över kvinnors och mäns utvecklingsmöjligheter inom vald befattning.<br><br>
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        VERKTYGET – ARBETSORGANISATION
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">
                                            Ytterligare fördjupningsmaterial finns inom området Arbetsorganisation.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Arbetsinnehåll och utveckling
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <work-content-and-development v-bind:disabled="writeopportunities == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></work-content-and-development>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Utvecklingsblock
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <manage-developmentblocks v-bind:disabled="writeopportunities == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></manage-developmentblocks>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Fördela arbetsuppgifter
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <manage-worktasks v-bind:disabled="writeopportunities == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></manage-worktasks>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Revision av kompetens
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <wage-employee-competences v-bind:disabled="writeopportunities == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-employee-competences>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Länk till rapport
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <equality-report-gender-position-development v-bind:disabled="writeopportunities == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></equality-report-gender-position-development>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>


                        </div>
                    </div>
                    <div v-if="hideequalpay == false" class="p-0 d-block d-md-none col-12">
                        <div class="lime my-1 mobile-button rounded" v-bind:class="{'selected':step == 4}" @click="step = 4">
                            <span v-html="'Lika lön för lika arbete'"></span>
                        </div>
                    </div>
                    <div v-if="step == 4" class="col-12 p-0">
                        <div class="col-12 p-0">
                            <v-expansion-panels variant="accordion">
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step4-lonesattning"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Mellan"
                                    data-manual-info-tags="equality,lika-arbete,lonesattning">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Lönesättning
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7" data-manual-info-body>
                                            För att lika lön för lika arbete ska kunna analyseras krävs att följande uppgifter läggs in i verktyget för område Lönesättning:<br><br>
                                            1.	Uppgifter om lönesystemets konstruktion. Det görs i stegen Värdera grundarbetet, Värdera utvecklingsblock, Individuella tillägg och Rörlig lönedel. <br>
                                            2.	Inplacering av individer.<br>
                                            3.	Pengar i systemet.<br><br>
                                            Är detta arbete redan gjort är rapporten om lika lön för lika arbete redan klar.<br><br>
                                            Klicka Befattning och Rapport Lika lön lika arbete.<br><br>
                                            Är arbetet <i>inte</i> gjort klickar du på nedanstående länk.<br><br>
                                            <a href="/wagesetting">Länk till Lönesättning – alla steg måste genomföras</a>
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Länk till rapport
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <equality-report-gender-position-salary v-bind:disabled="writeequalpay == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></equality-report-gender-position-salary>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>


                        </div>
                    </div>
                    <div v-if="hideequalpayequalwork == false" class="p-0 d-block d-md-none col-12">
                        <div class="lime my-1 mobile-button rounded" v-bind:class="{'selected':step == 5}" @click="step = 5">
                            <span v-html="'Lika lön för likvärdigt arbete'"></span>
                        </div>
                    </div>
                    <div v-if="step == 5" class="col-12 p-0">
                        <div class="col-12 p-0">
                            <v-expansion-panels variant="accordion">
                                <v-expansion-panel eager class='theme-lime'
                                    data-manual-info-block="equality-step5-likvardigt-arbete-metod"
                                    data-manual-info-scope="Scenario"
                                    data-manual-module="Equality"
                                    data-manual-overview-section="Equality"
                                    data-manual-complexity="Mellan"
                                    data-manual-info-tags="equality,likvardigt-arbete,method">
                                    <v-expansion-panel-title color="lime" data-manual-info-title>
                                        Lika lön för likvärdigt arbete
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded" data-manual-info-body>
                                        <div class="pt-2 pb-4 col-md-7">
                                            Arbetet sker i fem steg.<br><br>
                                            1.	Identifiera kvinnodominerade grupper.<br>
                                            2.	Identifiera grupp av likvärdigt arbete.<br>
                                            3.	Jämförelse och analys.<br>
                                            4.	Lönespridning.<br>
                                            5.	Åtgärder.<br><br>

                                            Länk till Lönesättning – Värdera grundarbetet....<br><br>
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel eager class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Identifiera kvinnodominerade grupper
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Med kvinnodominerad grupp avses grupp (inom vilken arbetstagarna utför lika arbete) som utför arbete som är eller brukar anses vara kvinnodominerat. <br><br>
                                                            Bedömningen om ett visst arbete är kvinnodominerat utgår i första hand utifrån förhållandena i arbetsgivarens verksamhet. Om mer än 60 procent av arbetstagarna inom en viss grupp är eller brukar vara kvinnor, anses arbetet vara kvinnodominerat. Det är inte meningen att man på arbetsplatsen ska göra historiska efterforskningar avseende könsfördelningen i olika arbeten. <br><br>
                                                            Lagstiftaren har angett att en grupp i det här sammanhanget kan bestå av en person.
                                                        </div>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel eager class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Identifiera grupp med likvärdigt arbete
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Finns det kvinnodominerade grupper i företaget får man undersöka om det finns någon grupp att jämföra den kvinnodominerade gruppens löner och anställningsförmåner med. Jämförelsegruppen (en av grupperna inom vilka arbetstagarna utför lika arbete) ska utföra arbete som är likvärdigt med den kvinnodominerade gruppens. Det betyder att jämförelsegruppen ska omfatta minst 40 procent män.<br><br>
                                                            Enligt diskrimineringslagen ska bedömningen av likvärdiga arbeten göras med hjälp av huvudkriterierna kunskap och färdigheter, ansvar, ansträngning och arbetsförhållanden. Det är alltså arbetets krav som ska bedömas. Detta ska inte blandas samman med olika personers kvalifikationer eller prestationer som utför ett visst arbete.<br><br>
                                                            Ofta blir det här fråga om att jämföra arbeten av helt olika slag. Arbetsdomstolen har i en dom ansett att en barnmorskas arbete varit likvärdigt med en klinikingenjörs. Även arbeten som omfattas av olika kollektivavtal kan vara likvärdiga och kan då jämföras. <br><br>
                                                            Lagen kräver att en strukturerad genomgång och metod används för att hitta likvärdiga arbeten. Det krävs inte att företaget använder systematisk arbetsvärdering. Oftast kan jämförelserna göras vid en genomgång av de olika arbetena med utgångspunkt från de faktorer som lagen anger. I mycket stora företag där personer med lika arbeten kan finnas på många olika platser i organisationen kan dock en jämförelse med utgångspunkt från lagens faktorer bli så omfattande att det är enklare att använda ett system. <br><br>
                                                            Det kan hända att det inte går att finna någon jämförelsegrupp.
                                                        </div>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel eager class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Jämförelse och analys
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Analysen ska koncentreras till att undersöka hur grupper med kvinnodominerat arbete avlönas i förhållande till andra grupper som inte är kvinnodominerade. I denna del av analysen är det värderingen av själva arbetet som är i fokus.<br><br>
                                                            Analysen av likvärdiga arbeten ska även ta hänsyn till en annan typsituation. Om det finns en kvinnodominerad grupp som har högre krav i arbetet men som trots detta har lägre lönenivå ska detta analyseras.
                                                        </div>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel eager class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Lönespridning
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            Skillnaden i lönespridning mellan den kvinnodominerade gruppen och jämförelsegruppen ska också studeras. I lagförarbetena anges att lönespridningen inom kvinnodominerade grupper ofta är mindre än inom andra. Detta skulle kunna tyda på att individuella arbetsprestationer i den kvinnodominerade gruppen värderas annorlunda än i andra grupper i företaget. Om så visar sig vara fallet behöver orsakerna analyseras.
                                                        </div>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel eager class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Åtgärder
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">
                                                            I de fall där löneskillnaderna mellan kvinnor och män inte kan förklaras av sakliga skäl som är oberoende av kön ska arbetsgivaren genomföra lönejusteringar och andra åtgärder för att uppnå lika lön för arbeten och prestationer som är att betrakta som likvärdiga.
                                                        </div>
                                                        <div class="mt-5">

                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        VERKTYGET – VÄRDERA GRUNDARBETET
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">
                                            Arbetsvärdering av grundarbetet bygger på att det finns väldefinierade arbetsuppgifter. Är detta arbete inte gjort måste du först göra detta.
                                        </div>

                                        <v-expansion-panels variant="accordion">

                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Förslag till värderingsfaktorer/grader/poäng
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <wage-evaluate-factors v-bind:disabled="writeequalpayequalwork == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-factors>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Ange riktarbeten
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <wage-evaluate-positions v-bind:disabled="writeequalpayequalwork == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-positions>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Värdera grundarbetet
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <wage-evaluate-basework v-bind:disabled="writeequalpayequalwork == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-basework>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                            <v-expansion-panels variant="accordion">
                                                <v-expansion-panel class='theme-orange'>
                                                    <v-expansion-panel-title color="orange">
                                                        Likvärdigt arbete – faktoranalys
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div class="pb-2">

                                                        </div>
                                                        <div class="mt-5">
                                                            <wage-evaluate-analysis v-bind:disabled="writeequalpayequalwork == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-analysis>
                                                        </div>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-expansion-panels>
                                        <div class="mt-5">

                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>


                        </div>
                    </div>
                    <div v-if="hideresult == false" class="p-0 d-block d-md-none col-12">
                        <div class="lime my-1 mobile-button rounded" v-bind:class="{'selected':step == 6}" @click="step = 6">
                            <span v-html="'Resultatet'"></span>
                        </div>
                    </div>
                    <div v-if="step == 6" class="col-12 p-0">
                        <div class="col-12 p-0">
                            <v-expansion-panels variant="accordion">
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Länk till rapport – Andel kvinnor i befattningen
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <equality-report-gender-distribution v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></equality-report-gender-distribution>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Länk till rapport – Lika möjligheter till utveckling
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <equality-report-gender-position-development v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></equality-report-gender-position-development>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Länk till rapport – Lön för lika arbete
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <equality-report-gender-position-salary v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></equality-report-gender-position-salary>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                                <v-expansion-panel class='theme-lime'>
                                    <v-expansion-panel-title color="lime">
                                        Likvärdigt arbete – Faktoranalys
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text class="top-expanded">
                                        <div class="pt-2 pb-4 col-md-7">

                                        </div>

                                        <v-expansion-panels variant="accordion">

                                        </v-expansion-panels>
                                        <div class="mt-5">
                                            <wage-evaluate-analysis  v-bind:disabled="writeresult == false" v-bind:model='model' v-bind:selectedJobPosition="selectedJobPosition" @positionSelected="positionSelected"></wage-evaluate-analysis>
                                        </div>


                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- to here -->

    </div>



    



</template>


<script>
    
   
    //tab 1
    import CommonRule from '../../common/common-rule.vue'

    
    //tab 2
    import ManageWorkpositions from '../workorganisation/manage-workpositions.vue'
    import WageEmployeeAdmin from '../wagesetting/wage-employee-admin.vue'

     
    //tab 3
    import WorkContentAndDevelopment from '../workorganisation/work-content-and-development.vue'
    import ManageDevelopmentblocks from '../workorganisation/manage-developmentblocks.vue'
    
    import ManageWorktasks from '../workorganisation/manage-worktasks.vue'
    
    
    import WageEmployeeCompetences from '../wagesetting/wage-employee-competences.vue'

   
    //tab 5
    import WageEvaluateFactors from '../wagesetting/wage-evaluate-factors.vue'
    import WageEvaluatePositions from '../wagesetting/wage-evaluate-positions.vue'
    import WageEvaluateBasework from '../wagesetting/wage-evaluate-basework.vue'
    import WageEvaluateAnalysis from '../wagesetting/wage-evaluate-analysis.vue'

    import EqualityReportGenderDistribution from './equality-report-gender-distribution.vue'  
    import EqualityReportGenderPositionDevelopment from './equality-report-gender-position-development.vue'
    import EqualityReportGenderPositionSalary from './equality-report-gender-position-salary.vue'

       
   

    export default {

        name: 'equality-main',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeoverview: {
                type: Boolean,
                required: false,
                default: false,
            },
            hidesexdistribution: {
                type: Boolean,
                required: false,
                default: false,
            },
            writesexdistribution: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideopportunities: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeopportunities: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideequalpay: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeequalpay: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideequalpayequalwork: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeequalpayequalwork: {
                type: Boolean,
                required: false,
                default: false,
            },
            hideresult: {
                type: Boolean,
                required: false,
                default: false,
            },
            writeresult: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonRule,
            ManageWorkpositions,
            WageEmployeeAdmin,
            WorkContentAndDevelopment,
            ManageDevelopmentblocks,
            ManageWorktasks,
            WageEmployeeCompetences,
            WageEvaluateFactors,
            WageEvaluatePositions,
            WageEvaluateBasework,
            WageEvaluateAnalysis,
            EqualityReportGenderDistribution,
            EqualityReportGenderPositionDevelopment,
            EqualityReportGenderPositionSalary,
        },
        methods: {
            positionSelected(newVal) {
                this.selectedJobPosition = newVal;
            },
            jobPositionsChanged(jobPositions) {
                if (!Array.isArray(jobPositions)) {
                    return;
                }

                this.internalModel.JobPositions = jobPositions;

                var highestId = null;
                for (var i = 0; i < jobPositions.length; i++) {
                    var id = jobPositions[i] && (jobPositions[i].JobPositionId || jobPositions[i].jobPositionId);
                    id = Number(id);
                    if (id > 0 && (highestId === null || id > highestId)) {
                        highestId = id;
                    }
                }

                if (highestId !== null) {
                    this.selectedJobPosition = highestId;
                }
            }
        },

        data() {
            return {
                step: 1,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                selectedJobPosition: null,
            };
        },
        watch: {
            //selectedPosition1: function(newVal){
            //    this.getWorkTasks(newVal);
            //    this.getWorkBlocks(newVal);
            //},

        },
        mounted() {
            this.internalModel = this.model;
            /*
            alert("hideoverview:" + this.hideoverview);
            alert("writeoverview:" + this.writeoverview);
            alert("hidesexdistribution:" + this.hidesexdistribution);
            alert("writesexdistribution:" + this.writesexdistribution);
            alert("hideopportunities:" + this.hideopportunities);
            alert("writeopportunities:" + this.writeopportunities);
            alert("hideequalpay:" + this.hideequalpay);
            alert("writeequalpay:" + this.writeequalpay);
            alert("hideequalpayequalwork:" + this.hideequalpayequalwork);
            alert("writeequalpayequalwork:" + this.writeequalpayequalwork);
            alert("hideresult:" + this.hideresult);
            alert("writeresult:" + this.writeresult);
            */

        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .large-button {
        text-align: center;
        display: grid;
        align-items: center;
        /*width:80px;*/
        min-height: 90px;
        background-color: blue;
        color: white;
        cursor: pointer;
        font-size: 15px;
    }

    .input {
        border: none;
        border-bottom: 1px solid #ccc;
    }

    td {
        word-wrap: break-word;
        word-break: break-all;
    }

    .drop {
        color: black;
        text-decoration: none;
        font-size: 20px;
    }

    .top-expanded {
    }

    .theme-purple .v-expansion-panel-title {
        background-color: #845893 !important;
        color: white !important;
    }

    .theme-purple .v-expansion-panel-text {
        background-color: #fbedff !important;
    }


    .theme-green .v-expansion-panel-title {
        background-color: #62B965 !important;
        color: white !important;
    }

    .theme-green .v-expansion-panel-text {
        background-color: #F1F1F1 !important;
    }

    .theme-orange .v-expansion-panel-title {
        background-color: #e79925 !important;
        color: white !important;
    }

    .theme-orange .v-expansion-panel-text {
        background-color: #fff7eb !important;
    }


    .theme-lime .v-expansion-panel-title {
        background-color: #BDCF5B !important;
        color: black !important;
    }

    .theme-lime .v-expansion-panel-text {
        background-color: #e8efc4 !important;
    }

    
    
</style>
